export default {
    path: '/taskManage',
    name: 'taskManage',
    component: () => import('@/views/taskManage/index.vue'),
    children: [
        {
            path: 'storeactivities',
            name: 'storeactivities',
            component: () => import('@/views/taskManage/store-activities/index.vue'),
            meta: {
                pageTitle: '任务管理',
            },
        },
        {
            path: 'storeactivities/entrance/:id',
            name: 'storeactivities/entrance',
            component: () => import('@/views/taskManage/store-activities/tabs/entrance/add.vue'),
            meta: {
                parent: '/taskManage/storeactivities',
            }
            // meta: {
            //     pageTitle: '门店活动 / 活动入口  / 编辑',
            // }
        },
        {
            path: 'storeactivities/configure/:id/:isCopy',
            name: 'storeactivities/configure',
            component: () => import('@/views/taskManage/store-activities/tabs/configure/add.vue'),
            meta: {
                parent: '/taskManage/storeactivities',
            }
            // meta: {
            //     pageTitle: '门店活动 / 活动配置  / 编辑',
            // }
        },
        {
            path: 'storeactivities/record/:id/:templateId',
            name: 'storeactivities/record',
            component: () => import('@/views/taskManage/store-activities/tabs/record/detail.vue'),
            meta: {
                parent: '/taskManage/storeactivities',
            }
            // meta: {
            //     pageTitle: '门店活动 / 活动记录  / 查看',
            // }
        },
        {
            path: '/distribution/storeSale',
            name: 'storeSale',
            component: () => import('@/views/distribution/storeSale/index.vue'),
            meta: {
                pageTitle: '门店售卖',
            }
        }
    ]
}
